import React from 'react';
import cadenaHidrogeno from 'img/cadena_hidrogeno.png';
import HelpContent from './HelpContent';

/*
 * Ayuda Reemplazo de combustibles fósiles por gas natural en procesos térmicos
 */

const ElectrificacionTermicaIndustriaHelp = () => (
  <HelpContent>
    <h1>Electrificación de usos térmicos en industria y minería</h1>
    <p>
    La industria en Chile es responsable de aproximadamente el 15% de las emisiones de Gases de Efecto Invernadero (GEI) en el sector energético. 
    Una porción significativa de estas emisiones deriva de la combustión destinada a cubrir demandas térmicas. 
    Actualmente, se cuenta con la capacidad técnica para electrificar directamente la mayoría del calor necesario para los procesos industriales. 
    Esto puede lograrse utilizando una combinación de tecnologías como bombas de calor industriales y sistemas de calefacción por resistencia eléctrica, 
    tal como las calderas eléctricas. Aunque la electrificación de procesos térmicos en la industria puede resultar económicamente viable a largo plazo, 
    será esencial contar con apoyo político para superar los retos iniciales de logística y financiamiento. Estos desafíos derivan de la complejidad 
    de la cadena de suministro, la inercia de la industria y la necesidad de una infraestructura eléctrica adecuada.
    Esta medida aplica a industrias varias, minas varias, azúcar, cemento, hierro, pesca, salitre, siderurgia y papel y celulosa.
 
    </p>
    <p>
      <strong>Trayectoria 1:</strong> la participación de electricidad en usos térmicos es 11,2% en 2030, un 18% en 2040 y alcanza un 27,6% en 2050.
    </p>
    <p>
      <strong>Trayectoria 2:</strong> la participación de electricidad en usos térmicos es 11,2% en 2030, un 18% en 2040 y alcanza un 55,2% en 2050.
    </p>
  </HelpContent>
);

export default ElectrificacionTermicaIndustriaHelp;
